"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _button = require("@insided/deprecated-preact-components/design-system-components/button");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ConfigureSystemEmailModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ConfigureSystemEmailModal, _PureComponent);

  var _super = _createSuper(ConfigureSystemEmailModal);

  function ConfigureSystemEmailModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ConfigureSystemEmailModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false
    });
    return _this;
  }

  (0, _createClass2.default)(ConfigureSystemEmailModal, [{
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var isLoading = this.state.isLoading;
      return (0, _preact.h)(_preactPortal.default, {
        into: "body"
      }, (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "System Email Configuration Required"
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("p", null, "To notify authors about moderation actions, you need to configure the system email first. This ensures that notifications are sent successfully and comply with your brand guidelines.")), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_button.ButtonGroup, null, (0, _preact.h)(_Button.default, {
        title: "Configure Emails",
        variant: "primary",
        onClick: function onClick() {
          return window.location.assign('/email/system-emails');
        },
        isLoading: isLoading,
        "data-qa": "configure-emails",
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: onClose,
        size: "medium"
      })))));
    }
  }]);
  return ConfigureSystemEmailModal;
}(_preactCompat.PureComponent);

var _default = ConfigureSystemEmailModal;
exports.default = _default;